export const INDENT = "  "

export interface IndentEdit {
	value: string
	caret: number
}

/**
 * A newline that keeps the current line's indentation, one level deeper after an
 * opening brace. A brace pair the caret sits inside opens up around the caret.
 */
export function indentedNewline(
	value: string,
	start: number,
	end: number,
): IndentEdit {
	const lineStart = value.lastIndexOf("\n", start - 1) + 1
	const indent = /^[ \t]*/.exec(value.slice(lineStart, start))![0]

	const before = value.slice(0, start)
	const after = value.slice(end)
	const previous = before.trimEnd().slice(-1)
	const next = after.trimStart().slice(0, 1)

	const opens = previous === "{" || previous === "["
	const closes =
		(previous === "{" && next === "}") || (previous === "[" && next === "]")
	const deeper = indent + INDENT

	if (closes) {
		// The closing brace drops to its own line and the caret lands between them.
		const inserted = `\n${deeper}\n${indent}`
		return {
			value: before + inserted + after,
			caret: start + 1 + deeper.length,
		}
	}

	const inserted = `\n${opens ? deeper : indent}`
	return { value: before + inserted + after, caret: start + inserted.length }
}
